module.exports = __webpack_public_path__ + "img/Icon-22.3098860f.png";